import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export function useHairstylistProfile() {
  const { currentUser } = useAuth();
  const [hairstylistProfile, setHairstylistProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setHairstylistProfile(null);
      setLoading(false);
      return;
    }

    const fetchHairstylistProfile = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, 'hairstylists'),
          where('userId', '==', currentUser.uid)
        );
        const snapshot = await getDocs(q);
        
        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          setHairstylistProfile({
            id: doc.id,
            ...doc.data(),
          });
        } else {
          setHairstylistProfile(null);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching hairstylist profile:', error);
        setHairstylistProfile(null);
      } finally {
        setLoading(false);
      }
    };

    fetchHairstylistProfile();
  }, [currentUser]);

  const isHairstylist = !!hairstylistProfile;

  return { hairstylistProfile, loading, isHairstylist };
}

